<template>
  <div v-if="fetched">
    <div v-if="Object.keys(userById).length === 0">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-else>
      <h2>Dane użytkownika</h2>
      <button class="btn btn-outline-dark" @click="handleBusinessUser">
        {{
          userById.user_profile.user.role !== "BUSINESS"
            ? `Oznacz użytkownika
        jako konto biznesowe`
            : `Usuń konto biznesowe`
        }}
      </button>
      <button
        type="button"
        class="btn btn-outline-dark mr-3"
        @click="
          blockOrUnblockReceivingOfMessagesForUser(userById.user_profile.user)
        "
      >
        {{
          userById.user_profile.user.blocked_receiving_of_messages
            ? "Odblokuj chat"
            : "Zablokuj chat"
        }}
      </button>
      <table class="table borderless">
        <thead>
          <tr class="tr-table">
            <th scope="col">ID użytkownika</th>
            <th scope="col">Status opiekuna</th>
            <th scope="col">Status seniora</th>
            <th scope="col">Ostatnia aktywność</th>
            <th scope="col">Telefon</th>
            <th scope="col">Nr tel. konta biznesowego</th>
            <th scope="col">Zweryfikowane konto bankowe?</th>
            <th scope="col">Ostatnie dane weryfikacyjne</th>
            <th scope="col">Zmiany</th>
            <th scope="col">Regulamin i polityka prywatności</th>
            <th scope="col">Zgoda marketingowa (telefon)</th>
            <th scope="col">Zgoda marketingowa (e-mail)</th>
            <th scope="col">Zaakceptowani partnerzy</th>
            <th scope="col">Kod SMS</th>
            <th scope="col">Kod polecający</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ userById.user_profile.user.id }}</td>
            <td>
              <div class="blockDecision">
                {{
                  !userById.user_profile.user.employee_blockade
                    ? "Niezablokowany"
                    : "Zablokowany"
                }}
                <span v-if="!userById.user_profile.user.employee_blockade">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-dark mr-3"
                    @click="
                      handleBlockOrUnblockUser(
                        userById.user_profile.user.id,
                        true,
                        'employee'
                      )
                    "
                  >
                    Zablokuj
                  </button>
                </span>
                <span v-else>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-dark mr-3"
                    @click="
                      handleBlockOrUnblockUser(
                        userById.user_profile.user.id,
                        false,
                        'employee'
                      )
                    "
                  >
                    Odblokuj
                  </button>
                </span>
              </div>
            </td>
            <td>
              <div class="blockDecision">
                {{
                  !userById.user_profile.user.senior_blockade
                    ? "Niezablokowany"
                    : "Zablokowany"
                }}

                <span v-if="!userById.user_profile.user.senior_blockade">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-dark mr-3"
                    @click="
                      handleBlockOrUnblockUser(
                        userById.user_profile.user.id,
                        true,
                        'senior'
                      )
                    "
                  >
                    Zablokuj
                  </button>
                </span>
                <span v-else>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-dark mr-3"
                    @click="
                      handleBlockOrUnblockUser(
                        userById.user_profile.user.id,
                        false,
                        'senior'
                      )
                    "
                  >
                    Odblokuj
                  </button>
                </span>
              </div>
            </td>
            <td>
              {{
                userById.user_profile.user.last_activity
                  ? formattedDate(userById.user_profile.user.last_activity)
                  : "Brak"
              }}
            </td>
            <td>{{ userById.user_profile.user.phone }}</td>
            <td>
              {{
                userById.user_profile.user.company_boss_phone_number
                  ? userById.user_profile.user.company_boss_phone_number
                  : "Brak"
              }}
            </td>
            <td>
              {{
                userById.user_profile.profile.payment_verification_status ===
                "ACCEPTED"
                  ? "TAK"
                  : "NIE"
              }}
            </td>
            <td>
              <button
                type="button"
                class="btn btn-outline-dark"
                data-toggle="modal"
                :data-target="`#verificationInfo${userById.user_profile.user.id}`"
              >
                Pokaż
              </button>
            </td>
            <td>
              <button
                type="button"
                class="btn btn-outline-dark btn-sm"
                data-toggle="modal"
                data-target="#userChanges"
                @click="setUserChanges(userById.user_profile.user.id)"
              >
                Zmiany
              </button>
            </td>
            <td>
              {{
                userById.user_profile.profile.regulations_accept_date !== null
                  ? formattedDate(
                      userById.user_profile.profile.regulations_accept_date
                    )
                  : "NIE"
              }}
            </td>
            <td>
              {{
                userById.user_profile.profile.newsletter_phone_accept_date !==
                null
                  ? formattedDate(
                      userById.user_profile.profile.newsletter_phone_accept_date
                    )
                  : "NIE"
              }}
            </td>
            <td>
              {{
                userById.user_profile.profile.newsletter_email_accept_date !==
                null
                  ? formattedDate(
                      userById.user_profile.profile.newsletter_email_accept_date
                    )
                  : "NIE"
              }}
            </td>
            <td>
              <button
                v-if="
                  userById.user_profile.profile.partners &&
                  userById.user_profile.profile.partners.length > 0
                "
                type="button"
                class="btn btn-outline-dark"
                data-toggle="modal"
                :data-target="`#userPartners`"
              >
                Pokaż
              </button>
              <p v-else>Brak</p>
            </td>
            <td>
              {{
                userById.user_profile.user.activation_token
                  ? userById.user_profile.user.activation_token
                  : "Brak"
              }}
            </td>
            <td>{{ userById.user_profile.user.referral_code }}</td>
            <!-- Dane ostatniej płatności weryfikacyjnej -->
            <div
              class="modal fade"
              :id="`verificationInfo${userById.user_profile.user.id}`"
              tabindex="-1"
              role="dialog"
              aria-labelledby="verificationInfo"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="verificationInfo">
                      Ostatnie dane weryfikacyjne
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      @click="changes = null"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <table class="table modal-table">
                      <thead>
                        <tr class="tr-table">
                          <th scope="col">Imię</th>
                          <th scope="col">Nazwisko</th>
                          <th scope="col">Numer konta</th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>
                            {{
                              userById.user_profile.user
                                .last_verification_account_first_name
                                ? userById.user_profile.user
                                    .last_verification_account_first_name
                                : "Brak"
                            }}
                          </td>
                          <td>
                            {{
                              userById.user_profile.user
                                .last_verification_account_last_name
                                ? userById.user_profile.user
                                    .last_verification_account_last_name
                                : "Brak"
                            }}
                          </td>
                          <td>
                            {{
                              userById.user_profile.user
                                .last_verified_account_number
                                ? userById.user_profile.user
                                    .last_verified_account_number
                                : "Brak"
                            }}
                          </td>
                          <td>
                            {{
                              userById.user_profile.user
                                .last_verification_status
                                ? userById.user_profile.user
                                    .last_verification_status
                                : "Brak"
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-outline-dark"
                      data-dismiss="modal"
                      @click="changes = null"
                    >
                      Zamknij
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="modal fade"
              id="userChanges"
              tabindex="-1"
              role="dialog"
              aria-labelledby="userChangesLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="userChanges">
                      Zmiany do weryfikacji
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      @click="changes = null"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <table
                      class="table modal-table"
                      v-if="changes && changes.length > 0"
                    >
                      <thead>
                        <tr class="tr-table">
                          <th scope="col">ID</th>
                          <th scope="col">Zmienione pole</th>
                          <th scope="col">Data</th>
                          <th scope="col">Poprzednia wartość</th>
                          <th scope="col">Nowa wartość</th>
                          <th scope="col">Rodzaj zmiany</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in changes" :key="item.id">
                          <td>{{ item.id }}</td>
                          <td>{{ item.changed_field }}</td>
                          <td>{{ formattedDate(item.creationDate) }}</td>
                          <td>
                            <span v-if="item.change_type === 'SERVICES'">
                              <ul
                                style="list-style-type: decimal"
                                v-if="item.before_change.split(',')[0]"
                              >
                                <span
                                  v-for="service in item.before_change.split(
                                    ','
                                  )"
                                  :key="service"
                                >
                                  {{ service }}
                                </span>
                              </ul>
                              <div v-else>Brak usług</div>
                            </span>
                            <span v-else>
                              {{
                                item.before_change ? item.before_change : "Brak"
                              }}
                            </span>
                          </td>
                          <td>
                            <span v-if="item.change_type === 'SERVICES'">
                              <ul style="list-style-type: decimal">
                                <span
                                  v-for="service in item.after_change.split(
                                    ','
                                  )"
                                  :key="service"
                                >
                                  {{ service }}
                                </span>
                              </ul>
                            </span>
                            <span v-else>
                              {{ item.after_change }}
                            </span>
                          </td>
                          <td>{{ item.change_type }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-else>
                      <div class="alert alert-danger notFoundListAlert">
                        Brak zmian od ostatniej akceptacji użytkowinka
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-outline-dark"
                      data-dismiss="modal"
                      @click="changes = null"
                    >
                      Zamknij
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="modal fade"
              id="userPartners"
              tabindex="-1"
              role="dialog"
              aria-labelledby="userChangesLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <table class="table modal-table">
                      <thead>
                        <tr class="tr-table">
                          <th scope="col">Nazwa</th>
                          <th scope="col">Data</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in userById.user_profile.profile.partners"
                          :key="item.id"
                        >
                          <td>{{ item.partner }}</td>
                          <td>{{ formattedDate(item.date_of_accept) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-outline-dark"
                      data-dismiss="modal"
                      @click="changes = null"
                    >
                      Zamknij
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </tr>
        </tbody>
      </table>

      <h2>Dane profilu</h2>
      <table
        class="table borderless"
        v-if="userById.user_profile && userById.user_profile.profile"
      >
        <thead>
          <tr class="tr-table">
            <th scope="col">ID profilu</th>
            <th scope="col">Utworzono</th>
            <th scope="col">Imię</th>
            <th scope="col">Nazwisko</th>
            <th scope="col">Data urodzenia</th>
            <th scope="col">Pesel</th>
            <th scope="col">Numer konta</th>
            <th scope="col">Ostatni zweryfikowany numer konta</th>
            <th scope="col">Status</th>
            <th scope="col">Zdjęcie</th>
            <th scope="col">Status pracownika</th>
            <th scope="col">Płatności</th>
            <th scope="col">Portfel</th>
            <th scope="col">Wiadomość</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ userById.user_profile.profile.id }}</td>
            <td>{{ userById.user_profile.user.creation_date }}</td>
            <td>{{ userById.user_profile.profile.first_name }}</td>
            <td>{{ userById.user_profile.profile.last_name }}</td>
            <td>
              {{
                userById.user_profile.profile.birthdate
                  ? formattedDateWithoutTime(
                      userById.user_profile.profile.birthdate
                    )
                  : ""
              }}
            </td>
            <td>{{ userById.user_profile.profile.pesel }}</td>
            <td>{{ userById.user_profile.profile.account_number }}</td>
            <td>
              {{ userById.user_profile.user.last_verified_account_number }}
            </td>
            <td>{{ userById.user_profile.profile.profile_status }}</td>
            <td>
              <a
                target="_blank"
                :href="
                  getUrl() +
                  '/api/profile/photo/' +
                  userById.user_profile.profile.file_path
                "
              >
                <img
                  class="img-avatar"
                  :src="
                    getUrl() +
                    '/api/profile/photo/' +
                    userById.user_profile.profile.file_path
                  "
                />
              </a>
            </td>
            <td>{{ userById.user_profile.profile.employee_status }}</td>

            <td>
              <router-link
                :to="{
                  name: 'PaymentsList',
                  query: { search: userById.user_profile.user.phone },
                }"
              >
                <button type="button" class="btn btn-outline-dark mr-3">
                  Płatności
                </button>
              </router-link>
            </td>
            <td>{{ userById.user_profile.wallet }}</td>

            <td>
              <router-link
                :to="{ path: '../../chat/' + userById.user_profile.user.id }"
              >
                <button type="button" class="btn btn-outline-dark mr-3">
                  Napisz
                </button>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Dane do faktury -->
      <InvoiceDataSection
        v-if="userById && userById.user_profile"
        :profile="userById.user_profile.profile"
        :userId="userById.user_profile.user.id"
        fieldPrefix="customer_"
        @updated="getUserData"
      />

      <div v-if="addedRatings && addedRatings.length > 0">
        <h2>Oceny wystawione przez tego użytkownika</h2>
        <table class="table borderless table-striped">
          <thead>
            <tr class="tr-table">
              <th scope="col">Utworzono</th>
              <th scope="col">Użytkownik, któremu wystawiono ocenę</th>
              <th scope="col">Ocena</th>
              <th scope="col">Komentarz</th>
              <th scope="col">Pokaż / Ukryj</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="rate in addedRatings" :key="rate.id">
              <td>{{ formattedDate(rate.creation_date) }}</td>
              <td>
                {{ rate.receiver.first_name }} {{ rate.receiver.last_name }},
                tel. {{ rate.receiver.phone }}
              </td>
              <td>{{ rate.value }}</td>
              <td>{{ rate.message }}</td>
              <td>
                <button
                  class="btn btn-sm btn-outline-dark hideButton"
                  v-if="!rate.is_hidden"
                  @click="hideOrShow(rate.id, 'hide')"
                >
                  Ukryj ocenę
                </button>

                <button
                  class="btn btn-sm but-outline-dark hideButton"
                  v-if="rate.is_hidden"
                  @click="hideOrShow(rate.id, 'show')"
                >
                  Pokaż ocenę
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="receivedRatings && receivedRatings.length > 0">
        <h2>Otrzymane oceny od innych użytkowników</h2>
        <table class="table borderless table-stiped">
          <thead>
            <tr class="tr-table">
              <th scope="col">Utworzono</th>
              <th scope="col">Użytkownik, od którego otrzymano ocenę</th>
              <th scope="col">Ocena</th>
              <th scope="col">Komentarz</th>
              <th scope="col">Pokaż / Ukryj</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="rate in receivedRatings" :key="rate.id">
              <td>{{ formattedDate(rate.creation_date) }}</td>
              <td>
                {{ rate.author.first_name }} {{ rate.author.last_name }}, tel.
                {{ rate.author.phone }}
              </td>
              <td>{{ rate.value }}</td>
              <td>{{ rate.message }}</td>
              <td>
                <button
                  class="btn btn-sm btn-outline-dark hideButton"
                  v-if="!rate.is_hidden"
                  @click="hideOrShow(rate.id, 'hide')"
                >
                  Ukryj ocenę
                </button>

                <button
                  class="btn btn-sm btn-outline-dark hideButton"
                  v-if="rate.is_hidden"
                  @click="hideOrShow(rate.id, 'show')"
                >
                  Pokaż ocenę
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <button
        type="button"
        class="btn btn-outline-dark"
        data-toggle="modal"
        :data-target="`#confirmDeletion`"
        id="confirmDeletionButton"
        style="visibility: hidden"
      ></button>

      <div class="modal fade" id="confirmDeletion">
        <div class="modal-dialog modal-sm">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Usuwanie konta użytkownika</h4>
              <button type="button" class="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div class="modal-body">
              <p>
                <label class="h-50">Na jakiej podstawie usuwasz konto?</label>
              </p>
              <textarea
                class="w-100"
                v-model="note"
                minlength="1"
                maxlength="1024"
                rows="10"
                required
              >
              </textarea>
              <button
                type="button"
                class="btn btn-danger w-100 mt-2"
                @click="deleteUser()"
                :disabled="!note || note.length === 0"
              >
                USUŃ
              </button>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                id="confirmDeletionClose"
              >
                Zamknij
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        style="display: flex; justify-content: center"
        v-if="userRole === 'ADMIN' || userRole === 'ADMIN1'"
      >
        <button
          class="btn btn-outline-dark"
          v-on:click="deleteUserHandler(userById.user_profile.user.id)"
        >
          USUŃ DANE UŻYTKOWNIKA
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../axios";
import mainAxios from "axios";
import { URL } from "../axios";
import shared from "../shared";
import store from "../store";
import InvoiceDataSection from "../components/InvoiceDataSection.vue";

export default {
  name: "user-details",
  components: { InvoiceDataSection },
  data: function () {
    return {
      id_user: null,
      ratingStatusChanging: false,
      note: "",
      changes: [],
      fetched: false,
    };
  },
  computed: {
    userById() {
      // console.log("HERE");
      // console.log(this.$store.getters.getUserById);
      this.fetchData();
      return this.$store.getters.getUserById;
    },
    userCommissionMessage() {
      return this.$store.getters.getUserCommissionMessage;
    },
    userRole() {
      return this.$store.getters.getUserRole;
    },
    addedRatings() {
      return this.$store.getters.getAddedRatings;
    },
    receivedRatings() {
      return this.$store.getters.getReceivedRatings;
    },
  },

  beforeRouteEnter(to, from, next) {
    store.dispatch("fetchUserByPhoneOrUserId", {
      param: to.params.id,
    });
    next();
  },
  // mounted() {
  //   this.$store.dispatch("fetchAddedRatings", {
  //     user_id: this.$route.params.id,
  //   });
  //   this.$store.dispatch("fetchReceivedRatings", {
  //     user_id: this.$route.params.id,
  //   });
  // },

  async created() {
    this.id_user = this.$route.params.id;
    await this.getUserData();
    this.formattedDateWithoutTime = shared.formattedDateWithoutTime;
    this.formattedDate = shared.formattedDate;
    this.$store.dispatch("fetchAddedRatings", {
      user_id: this.$route.params.id,
    });
    this.$store.dispatch("fetchReceivedRatings", {
      user_id: this.$route.params.id,
    });
    this.fetched = true;
  },
  methods: {
    async blockOrUnblockReceivingOfMessagesForUser(user) {
      try {
        this.loading = true;
        const isBlocked = user.blocked_receiving_of_messages ? true : false;
        await axios.put(
          `api/user/${user.id}/blockedReceivingOfMessages?block=${!isBlocked}`
        );
        this.getUserData();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleBusinessUser() {
      try {
        if (this.userById.user_profile.user.role !== "BUSINESS") {
          await axios.post(`/api/admin/business-user/${this.id_user}`);
        } else {
          await axios.put(`/api/admin/business-user/remove/${this.id_user}`);
        }
        this.getUserData();
      } catch (e) {
        console.log(e);
      }
    },
    setUserChanges(userId) {
      const url = `/api/profileChange/${userId}`;
      axios
        .get(url)
        .then((response) => {
          this.changes = response.data;
        })
        .catch((err) => console.log(err));
    },

    async hideOrShow(ratingId, action) {
      if (this.ratingStatusChanging === false) {
        this.ratingStatusChanging = true;
        const url = `/api/rating/${ratingId}/hidden?status=${action}`;
        try {
          const res = await axios.put(url);
          if (res) {
            this.fetchData();
            setTimeout(() => {
              this.changeStatus();
            }, 3000);
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    fetchData() {
      this.$store.dispatch("fetchAddedRatings", {
        user_id: this.$route.params.id,
      });
      this.$store.dispatch("fetchReceivedRatings", {
        user_id: this.$route.params.id,
      });
    },
    changeStatus() {
      this.ratingStatusChanging = false;
    },
    async handleBlockOrUnblockUser(userId, decision, role) {
      let body;
      if (role === "employee") {
        body = {
          employee_blockade: decision,
        };
      }
      if (role === "senior") {
        body = {
          senior_blockade: decision,
        };
      }
      axios.put(`/api/user/${userId}/blockades`, body).then(() => {
        this.getUserData();
      });
    },
    getUrl() {
      return URL;
    },
    getUserData() {
      this.$store.dispatch("getUserById", {
        userId: this.$route.params.id,
      });
    },
    async deleteUser() {
      const confirm = prompt(
        `Czy na pewno chcesz usunąć konto? Potwierdź wpisując 'TAK'`
      );
      if (confirm.toUpperCase() === "TAK") {
        try {
          this.id_user = this.$route.params.id;
          const url = `api/user/${this.id_user}?note=${this.note}&confirmation=true`;
          await axios.delete(url);
          this.$notify({
            group: "success",
            text: "Usunięto dane użytkownika",
          });

          this.$router.push("../");
          document.getElementById("confirmDeletionClose").click();
        } catch (err) {
          if (err.response.data.error === "money_in_wallet") {
            this.$notify({
              group: "error",
              text: "W portfelu użytkownika znajdują się środki, poinformuj go o tym",
            });
          }
        }
      }
    },
    async deleteUserHandler(id) {
      const url = `${URL}/api/user/${id}`;
      const token = window.localStorage.getItem("SAtoken");

      try {
        mainAxios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        await mainAxios.delete(url);
      } catch (error) {
        const err = error.response.data.error;
        if (err === "money_in_wallet") {
          this.$notify({
            group: "error",
            text: "W portfelu użytkownika znajdują się środki, poinformuj go o tym",
          });
        } else if (err === "note_required") {
          document.getElementById("confirmDeletionButton").click();
        } else if (err.includes("_PLN_from_admins")) {
          const confirm = prompt(
            `W portfelu użytkownika znajduje się kwota ${
              err.split("_")[0]
            }zł, która jest równa kwocie wpłat bonusowych od adminów. Aby kontynuować i mimo to usunąć konto tego użytkownika potwierdź wpisując 'TAK'`
          );
          if (confirm.toUpperCase() === "TAK") {
            document.getElementById("confirmDeletionButton").click();
          }
        } else {
          console.log(error);
          alert("Błąd przy usuwaniu danych użytkownika");
        }
      }
    },
  },
};
</script>

<style scoped>
.blockDecision {
  display: flex;
  flex-direction: column;
}
.blockDecision input {
  margin-right: 5px;
}
.topform {
  width: 300px;
}
.topform input {
  width: 300px;
}
</style>
